import { render } from "./DatosRegistro.vue?vue&type=template&id=621d2e54"
import script from "./DatosRegistro.vue?vue&type=script&lang=js"
export * from "./DatosRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__